export default __webpack_public_path__ + "static/media/A0002.221e7e0f.png";